class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.targetTime = new Date(this.dataset.target).getTime();
    this.activeEl = this.querySelector('[data-countdown-active]');
    this.expiredEl = this.querySelector('[data-countdown-expired]');

    if (isNaN(this.targetTime)) {
      this.showExpired();
      return;
    }

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const diff = this.targetTime - Date.now();

    if (diff <= 0) {
      this.showExpired();
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    this.setValue('days', days);
    this.setValue('hours', hours);
    this.setValue('minutes', minutes);
    this.setValue('seconds', seconds);
  }

  setValue(unit, value) {
    const el = this.querySelector(`[data-countdown-${unit}]`);
    if (el) el.textContent = String(value).padStart(2, '0');
  }

  showExpired() {
    clearInterval(this.interval);
    if (this.activeEl) this.activeEl.hidden = true;
    if (this.expiredEl) this.expiredEl.hidden = false;
  }
}

customElements.define('countdown-timer', CountdownTimer);
